import fetchAPI from '../utils/fetchAPI';

type TParams = {
  postcode: string;
  sellerGeoLocation: number[];
};

export default function getSellerDistance({ sellerGeoLocation, postcode }: TParams): Promise<string> {
  try {
    return fetchAPI({
      url: `/v/api/seller-distance/${encodeURIComponent(sellerGeoLocation.join(','))}/${encodeURIComponent(postcode.replace(/ /g, ''))}`,
    });
  } catch (e) {
    return Promise.resolve('') as Promise<string>;
  }
}
